import React, { useEffect } from 'react';

export const QClearForm = ({ renderComponent }) => {
    useEffect(() => {
        renderComponent( false );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    return <></>
}
